import {IIconProps} from '../DataStoreIcon';

const Honeycomb = ({width = '20', height = '20'}: IIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3515 15.4971L14.4238 19.1207L12.3515 22.7467H8.23127L6.16113 19.1207L8.23127 15.4971H12.3515Z"
      fill="#FFB000"
    />
    <path
      d="M12.3515 6.74902L14.4238 10.3727L12.3515 13.9986H8.23127L6.16113 10.3727L8.23127 6.74902H12.3515Z"
      fill="#64BA00"
    />
    <path
      d="M5.05811 11.749L6.74641 14.7461L5.05811 17.7476H1.68828L0 14.7461L1.68828 11.749H5.05811Z"
      fill="#F96E10"
    />
    <path
      d="M21.3201 0.000976562L24 4.74634L21.3201 9.49843H15.9337L13.2539 4.74634L15.9337 0.000976562H21.3201Z"
      fill="#0298EC"
    />
  </svg>
);

export default Honeycomb;
